// import Vue from 'vue'
const state = {
    userId: {
        CLIENT_ID: '',
        CLIENT_SECRET: '',
        GRANT_TYPE: 'client_credentials',
    },
    user_token: '',
    status: false,
};

const actions = {
};

const mutations = {
    SET_USERID(state, user) {
        state.userId.CLIENT_ID = user.CLIENT_ID;
        state.userId.CLIENT_SECRET = user.CLIENT_SECRET;
    },
    SET_USERSTATUS(state, status) {
        state.status = status;
    },
    SET_USER_TOKEN(state, token) {
        if (token) {
            state.user_token = token;
        } else {
            state.user_token = '';
        }
    },
};

export default {
    state,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/user.js